// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-3d"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.6604 7L12.0001 2L3.33984 7L3.33984 17L12.0001 22L20.6604 17L20.6604 7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0001 20.95L12.0001 12.75M19.751 7.525L12.0001 12L4.24916 7.52501M20.6604 7L12.0001 2L3.33984 7L3.33984 17L12.0001 22L20.6604 17L20.6604 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.0001 6L12.0001 8M15.464 14L17.1961 15M8.53625 14L6.8042 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Chart3DIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-3d',
    ref,
    icon: element,
  },
));

Chart3DIcon.displayName = 'Chart3DIcon';

export default Chart3DIcon;
